import React, { type PropsWithChildren } from 'react';
import { Flex, Heading, Text } from '@chakra-ui/react';
import { useBreakpoint } from 'ts/common/hooks';

interface Props {
    subtitle?: string;
}

const ClientPageHeading = ({ children, subtitle }: PropsWithChildren<Props>) => {
    const isLargeScreen = useBreakpoint();

    return (
        <Flex
            backgroundColor="brand.primary"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
            padding="16px"
            boxSizing="border-box"
            height="100%"
            width="100%"
        >
            <Heading
                as="h1"
                letterSpacing={isLargeScreen ? '6px' : '3px'}
                fontSize={isLargeScreen ? '3xl' : '2xl'}
                color="background"
                textTransform="uppercase"
                margin={0}
                size={isLargeScreen ? '3xl' : '2xl'}
                textAlign="center"
                textShadow="0px 5px 9px rgba(0, 0, 0, 0.25)"
            >
                {children}
            </Heading>
            {subtitle && (
                <Text textAlign="center" fontSize="lg" color="background" fontWeight="normal">
                    {subtitle}
                </Text>
            )}
        </Flex>
    );
};

export default ClientPageHeading;
